var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgingGaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 95,
    viewBox: "0 0 120 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_23816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9291 49.6815C91.39 49.6458 90.8518 49.7644 90.3776 50.0233C89.9034 50.2823 89.5127 50.6709 89.2511 51.1437C89.2427 51.1591 89.2302 51.172 89.2151 51.1809C89.1999 51.1899 89.1826 51.1946 89.165 51.1946C89.1474 51.1946 89.1302 51.1898 89.115 51.1808C89.0999 51.1719 89.0874 51.159 89.079 51.1435C88.8188 50.6707 88.4291 50.282 87.9557 50.023C87.4822 49.764 86.9447 49.6455 86.4062 49.6815C85.9311 49.6641 85.4576 49.7463 85.0161 49.9228C84.5747 50.0993 84.175 50.3661 83.8427 50.7062C83.5105 51.0463 83.2531 51.4521 83.087 51.8976C82.9208 52.3431 82.8497 52.8183 82.8782 53.2929C82.8615 54.2298 83.1143 55.1517 83.6066 55.9489C84.6979 57.7887 88.2929 59.6591 89.0314 60.129C89.0712 60.1544 89.1175 60.168 89.1647 60.168C89.212 60.1681 89.2583 60.1546 89.2982 60.1293C90.0372 59.6616 93.6329 57.8031 94.7327 55.9489C95.2246 55.1515 95.477 54.2296 95.4598 53.2929C95.488 52.8181 95.4166 52.3427 95.2502 51.8972C95.0838 51.4517 94.8261 51.0459 94.4936 50.7058C94.1612 50.3658 93.7613 50.099 93.3196 49.9226C92.878 49.7462 92.4044 49.664 91.9291 49.6815Z",
    stroke: "#F69A4D",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5722 65.9734H60.2923C59.2603 65.9734 58.2706 65.5635 57.541 64.8338C56.8113 64.1041 56.4014 63.1144 56.4014 62.0824V35.3327C56.4014 34.8217 56.502 34.3157 56.6975 33.8437C56.8931 33.3716 57.1797 32.9427 57.541 32.5814C57.9023 32.2201 58.3312 31.9335 58.8033 31.7379C59.2753 31.5424 59.7813 31.4418 60.2923 31.4418H97.5722C98.0832 31.4418 98.5891 31.5424 99.0612 31.7379C99.5332 31.9335 99.9622 32.2201 100.323 32.5814C100.685 32.9427 100.971 33.3716 101.167 33.8437C101.362 34.3157 101.463 34.8217 101.463 35.3327V62.0826C101.463 62.5935 101.362 63.0995 101.167 63.5715C100.971 64.0436 100.685 64.4725 100.323 64.8338C99.9622 65.1951 99.5332 65.4817 99.0612 65.6773C98.5891 65.8728 98.0831 65.9734 97.5722 65.9734Z",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6258 65.9734H72.2412V71.9296H85.6258V65.9734Z",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6131 71.9297H62.2532C60.9274 71.9297 59.8525 73.0045 59.8525 74.3304V80.8683C59.8525 82.1942 60.9274 83.269 62.2532 83.269H95.6131C96.9389 83.269 98.0138 82.1942 98.0138 80.8683V74.3304C98.0138 73.0045 96.9389 71.9297 95.6131 71.9297Z",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2539 71.9297H108.817V50.4502C108.818 49.5644 109.17 48.7154 109.797 48.0897C110.424 47.4641 111.274 47.1132 112.16 47.1141C113.046 47.1132 113.896 47.4641 114.523 48.0897C115.15 48.7154 115.502 49.5644 115.503 50.4502V74.7238",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.507 83.8445H115.501C114.774 83.8445 114.077 83.5558 113.563 83.0417C113.049 82.5277 112.76 81.8305 112.76 81.1036V74.9595H118.248V81.1036C118.248 81.4635 118.177 81.82 118.039 82.1525C117.901 82.4851 117.699 82.7872 117.445 83.0418C117.19 83.2963 116.888 83.4982 116.556 83.6359C116.223 83.7737 115.867 83.8446 115.507 83.8445Z",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.062 93.1818C109.119 93.1817 107.255 92.4108 105.879 91.0382C104.504 89.6656 103.729 87.8035 103.725 85.8602",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.062 88.153C110.454 88.1536 109.87 87.9124 109.439 87.4825C109.008 87.0525 108.765 86.469 108.765 85.8602",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7812 77.5992H85.0852",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6836 43.4213H67.1706L69.5606 41.0313L72.78 44.8245L75.9022 39.0315L77.8048 43.156H82.8776",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8959 19.68C36.3568 19.6443 35.8186 19.7629 35.3444 20.0219C34.8702 20.2808 34.4795 20.6694 34.2179 21.1422C34.2095 21.1576 34.197 21.1705 34.1819 21.1794C34.1667 21.1884 34.1494 21.1931 34.1318 21.1931C34.1142 21.1931 34.097 21.1883 34.0818 21.1794C34.0667 21.1704 34.0543 21.1575 34.0458 21.1421C33.7856 20.6693 33.3959 20.2805 32.9225 20.0215C32.449 19.7625 31.9115 19.6441 31.373 19.68C30.8979 19.6626 30.4244 19.7449 29.9829 19.9213C29.5414 20.0978 29.1418 20.3647 28.8095 20.7047C28.4773 21.0448 28.2199 21.4506 28.0538 21.8961C27.8876 22.3416 27.8165 22.8169 27.845 23.2915C27.8283 24.2283 28.0811 25.1502 28.5734 25.9475C29.6647 27.7873 33.2597 29.6576 33.9982 30.1275C34.038 30.153 34.0843 30.1665 34.1315 30.1666C34.1788 30.1666 34.2251 30.1532 34.265 30.1278C35.004 29.6601 38.5997 27.8016 39.6995 25.9474C40.1914 25.15 40.4438 24.2281 40.4266 23.2914C40.4548 22.8167 40.3834 22.3413 40.217 21.8958C40.0506 21.4502 39.7929 21.0444 39.4604 20.7044C39.128 20.3643 38.7281 20.0975 38.2864 19.9211C37.8448 19.7447 37.3712 19.6626 36.8959 19.68Z",
    stroke: "#F69A4D",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5399 35.972H5.26003C4.22809 35.972 3.23842 35.562 2.50873 34.8323C1.77905 34.1026 1.36913 33.1129 1.36914 32.081V5.3312C1.36914 4.82024 1.46978 4.31428 1.66531 3.84222C1.86085 3.37015 2.14744 2.94122 2.50875 2.57992C2.87005 2.21861 3.29898 1.93201 3.77105 1.73648C4.24311 1.54094 4.74907 1.4403 5.26003 1.44031H42.54C43.0509 1.4403 43.5569 1.54094 44.0289 1.73648C44.501 1.93201 44.9299 2.21861 45.2912 2.57992C45.6526 2.94122 45.9392 3.37015 46.1347 3.84221C46.3302 4.31428 46.4309 4.82024 46.4309 5.3312V32.0811C46.4309 32.592 46.3302 33.098 46.1347 33.5701C45.9392 34.0421 45.6526 34.4711 45.2912 34.8324C44.9299 35.1937 44.501 35.4803 44.0289 35.6758C43.5569 35.8714 43.0509 35.972 42.5399 35.972Z",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.207 39.342V35.9719H30.5917V39.342C30.5917 39.6816 30.5248 40.0179 30.3948 40.3317C30.2648 40.6454 30.0743 40.9305 29.8342 41.1707C29.594 41.4108 29.309 41.6013 28.9952 41.7313C28.6814 41.8612 28.3451 41.9281 28.0055 41.9281H19.7932C19.1073 41.9281 18.4495 41.6557 17.9645 41.1707C17.4795 40.6857 17.207 40.0279 17.207 39.342Z",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65137 13.4201H12.1384L14.5283 11.0301L17.7478 14.8233L20.87 9.03027L22.7726 13.1548H27.8454",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9014 47.9995V60.0081H48.2886",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7178 46.8231V66.9715H46.7973",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.459 49.8877L27.9186 47.2157L30.3433 49.8877",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0947 64.5299L47.7668 66.9895L45.0947 69.4143",
    stroke: "black",
    strokeWidth: 1.68053,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_23816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 95,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgingGaps);
export default __webpack_public_path__ + "static/media/bridging_gaps.5c3fe3d9948e4f35277a7fa168c97445.svg";
export { ForwardRef as ReactComponent };